module.exports = __webpack_public_path__ + "media/fonts/OFN-v2-8049f5574fa1cbca354947cde8ffa418.eot";